import request from '@/utils/request'

let ExchangeApi = {

  /*商品兑换列表*/
  list(data) {
    return request._post('/shop/plus.exchange.Index/index', data);
},
/*添加商品兑换*/
add(data) {
    return request._post('/shop/plus.exchange.Index/add', data);
},
/*修改商品兑换*/
edit(data) {
    return request._post('/shop/plus.exchange.Index/edit', data);
},
/*删除商品兑换*/
del(data) {
    return request._post('/shop/plus.exchange.Index/del', data);
},
/*商品兑换详情*/
detail(data) {
  return request._post('/shop/plus.exchange.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.exchange.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.exchange.Setting/getSetting', data, errorback);
    },
}
export default ExchangeApi;



// WEBPACK FOOTER //
// ./src/api/exchange.js